import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useTag, Tags } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<Tags>
      useData={useTag}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
